module.exports = __webpack_public_path__ + "static/media/virus.43afd669.png";